// extracted by mini-css-extract-plugin
export default {"form":"EditGoalHierarchy_form__1-gLN","treeEditorWrapper":"EditGoalHierarchy_treeEditorWrapper__VTAen"};